import type { Trip } from '@bambi/api-client/schemas';

import { dateTimeToDate } from 'src/common/date/dateTimeToDate';

export function getTripDateFormValue(trip: Trip) {
  const isClonedTrip = !trip.id && trip.scheduled_pickup_at;
  return isClonedTrip ? '' : dateTimeToDate(trip.scheduled_pickup_at);
}
